import React, { useState, useEffect, useRef } from 'react';

const ListControls = ({
  searchValue,
  onSearchChange,
  searchPlaceholder = 'Search...',
  sortValue,
  onSortChange,
  sortOptions = [],
  perPage,
  onPerPageChange,
  totalItems
}) => {
  const [localSearch, setLocalSearch] = useState(searchValue || '');
  const debounceRef = useRef(null);

  // Sync external changes
  useEffect(() => {
    setLocalSearch(searchValue || '');
  }, [searchValue]);

  const handleSearchInput = (e) => {
    const val = e.target.value;
    setLocalSearch(val);
    if (debounceRef.current) clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => {
      onSearchChange(val);
    }, 300);
  };

  const perPageOptions = [10, 25, 50, 0]; // 0 = All

  return (
    <div className="lc-container">
      <input
        type="text"
        className="lc-searchInput"
        placeholder={searchPlaceholder}
        value={localSearch}
        onChange={handleSearchInput}
      />
      {sortOptions.length > 0 && (
        <select
          className="lc-sortSelect"
          value={sortValue}
          onChange={(e) => onSortChange(e.target.value)}
        >
          {sortOptions.map(opt => (
            <option key={opt.value} value={opt.value}>{opt.label}</option>
          ))}
        </select>
      )}
      <select
        className="lc-perPageSelect"
        value={perPage}
        onChange={(e) => onPerPageChange(parseInt(e.target.value))}
      >
        {perPageOptions.map(n => (
          <option key={n} value={n}>{n === 0 ? 'All' : n}</option>
        ))}
      </select>
      {totalItems != null && (
        <span className="lc-resultCount">Showing {totalItems} result{totalItems !== 1 ? 's' : ''}</span>
      )}
    </div>
  );
};

export default ListControls;
